module.exports = __webpack_public_path__ + "static/media/Logistics-Companies.e1be3990.jpg";